import { CommonService } from 'dashboard-services/services';

const sharedState = CommonService.createThrottleState()
// true if you want to see values for debugging purposes
const DEBUG_THROTTLE = false
const CONCURRENT_CALLS_LIMIT = 10
let maxOccupied = 0

const logThrottleState = label => {
  if (!DEBUG_THROTTLE) {
    return
  }
  const inflight = sharedState.inflight
  const coolingDown = sharedState.reservedUntil.length
  const queue = sharedState.queue.length
  const occupied = inflight + coolingDown
  maxOccupied = Math.max(maxOccupied, occupied)
  console.info(`[Throttle:${label}]`, {
    occupied,
    limit: CONCURRENT_CALLS_LIMIT,
    inflight,
    coolingDown,
    queue,
    maxOccupied
  })
}

const createThrottle = (label, cooldownMs) => {
  const throttledFetch = CommonService.throttle(fetch.bind(window), CONCURRENT_CALLS_LIMIT, cooldownMs, sharedState)

  return (...args) => {
    logThrottleState(`${label}:before`)
    const result = throttledFetch(...args)
    logThrottleState(`${label}:after-enqueue`)
    result.finally(() => {
      setTimeout(() => logThrottleState(`${label}:settled`), 0)
    })
    return result
  }
}

export const defaultThrottledFetch = createThrottle("default", 5000)
export const throttledFetchNoMillisLimit = createThrottle("datapoint", 0)